import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import { installDocumentInputModality } from './utils/documentInputModality';

// Installed before the first render so the tap or keypress that opens the
// very first sheet is already classified.
installDocumentInputModality();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
